// NEW_FILE_JUSTIFIED: Renewal sub-section for consolidated insurance settings page — extracted from RenewalSettingsDialog
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { RenewalGeneralTab } from '@/components/insurance/RenewalGeneralTab';
import { RenewalEmailTemplateTab } from '@/components/insurance/RenewalEmailTemplateTab';
import { RenewalSmsTemplateTab } from '@/components/insurance/RenewalSmsTemplateTab';
import { RenewalCompanyEmailTemplateTab } from '@/components/insurance/RenewalCompanyEmailTemplateTab';
import type { IInsuranceSettingsRenewalSectionProps } from '@/@types/insurance';

const EMAIL_VARIABLES = [
  'customerName',
  'policyNumber',
  'expiryDate',
  'startDate',
  'insuranceType',
  'regNumber',
  'premium',
  'orgName',
];

const SMS_VARIABLES = ['customerName', 'policyNumber', 'expiryDate', 'orgName'];

const COMPANY_VARIABLES = ['companyName', 'employeeList', 'orgName'];

export function InsuranceSettingsRenewalSection({
  renewalState,
  renewalDispatch,
}: IInsuranceSettingsRenewalSectionProps) {
  return (
    <div className="space-y-6 p-6">
      <RenewalGeneralTab
        renewalDays={renewalState.renewalDays}
        smsFallbackDays={renewalState.smsFallbackDays}
        onRenewalDaysChange={days => renewalDispatch({ type: 'SET_RENEWAL_DAYS', value: days })}
        onSmsFallbackDaysChange={days =>
          renewalDispatch({ type: 'SET_SMS_FALLBACK_DAYS', value: days })
        }
        notificationMode={renewalState.notificationMode}
        onNotificationModeChange={mode =>
          renewalDispatch({ type: 'SET_NOTIFICATION_MODE', value: mode })
        }
      />

      <Tabs defaultValue="email-template">
        <TabsList className="grid w-full grid-cols-3">
          <TabsTrigger value="email-template">Email Template</TabsTrigger>
          <TabsTrigger value="sms-template">SMS Template</TabsTrigger>
          <TabsTrigger value="company-template">Company Template</TabsTrigger>
        </TabsList>

        <TabsContent value="email-template" className="mt-4">
          <RenewalEmailTemplateTab
            template={renewalState.emailTemplate}
            onTemplateChange={t => renewalDispatch({ type: 'SET_EMAIL_TEMPLATE', value: t })}
            availableVariables={EMAIL_VARIABLES}
            templateType="email"
          />
        </TabsContent>

        <TabsContent value="sms-template" className="mt-4">
          <RenewalSmsTemplateTab
            template={renewalState.smsTemplate}
            onTemplateChange={t => renewalDispatch({ type: 'SET_SMS_TEMPLATE', value: t })}
            availableVariables={SMS_VARIABLES}
            templateType="sms"
          />
        </TabsContent>

        <TabsContent value="company-template" className="mt-4">
          <RenewalCompanyEmailTemplateTab
            template={renewalState.companyEmailTemplate}
            onTemplateChange={t =>
              renewalDispatch({ type: 'SET_COMPANY_EMAIL_TEMPLATE', value: t })
            }
            availableVariables={COMPANY_VARIABLES}
            templateType="company_email"
          />
        </TabsContent>
      </Tabs>
    </div>
  );
}
